import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import { commandWorkspacePluginList } from '../actions';
import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { pluginId } = action;

  const workspacePluginDelete = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_WORKSPACE_PLUGIN_DELETE,
    pluginId,
  });

  if (workspacePluginDelete.type === constants.RTM_WORKSPACE_PLUGIN_DELETE_OK) {
    yield put(commandWorkspacePluginList());
  } else {
    yield put(pushToast({
      type: 'simple',
      message: workspacePluginDelete.message || <FormattedMessage {...messages.failedWorkspacePluginDeleteError} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_PLUGIN_DELETE, catchErrors, sendRequest, connection);
}
